<template>
    <div v-bind:class="!isOpen ? 'none' : 'block'" class="adGroupWrapper"> 
        <div class="adGroup" :class="campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER') ? 'disableCampaign' : ''">
            <div class="sectionWrapper"> 
                <div class="section"> 
                    <div> 
                        <div v-if="((!this.adGroupName || !this.isValidAdGroupName()) && this.validationErrorMessageForAdGroupName)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                            <div  class="errorHeading" ><img alt="img" src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ validationErrorMessageForAdGroupName }}</div>
                        </div>
                        <div v-if="(this.isDisabled  || this.adGroupState == 0 || this.adGroupState == 1 || this.adGroupState == 3)" style="margin: unset; margin-bottom: 1%" class="warningContainer"> 
                            <div  class="warningHeading" ><img alt="img" src="../assets/info.png" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.adGroupStateMessage }}</div>
                        </div>
                        <div> 
                            <div  class="heading required">Ad group name</div>
                            <div class="content"> 
                                <input class="textbox" v-model="adGroupName" :disabled="isDisabled" @keyup="handleInputDebounced" placeholder="Enter Ad group name" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="((this.products?.length === 0 ) && this.validationErrorMessage || this.errorMessage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img alt="img" src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage || this.errorMessage }}</div>
                </div>
                <ProductSelection 
                    v-bind:targeting="false" 
                    :clearForm="clearProductSelection"  
                    @productsAdded="getProductsFromChild"
                    @invalidCsvUploaded="onInvalidCsvUpload"
                    @clearErrorMessage="onClearErrorMessage"
                    :campaignData="this.campaignData"
                    :products="this.productsArray"
                    :sellerIdRole="this.sellerIdRole"
                    :count="this.count"
                    :isdisabled="this.isDisabled"
                    :selectionType="'products'"
                    @CsvUploadLimitExceeded="CsvUploadLimitExceededFromChild"
                />
            </div>
        </div>
    
        <div v-if="this.selectedTargetingType === 'Keyword' " class="adGroup targeting" :class="campaignClass === 'Privilege' && (role === 'BRAND' || role === 'SELLER') ? 'disableCampaign' : ''">
            <div class="header"> 
                <div class="title" style="padding-bottom: 22px">Ad Group - Targeting
                    <img alt="img" src="../assets/info.svg"/>
                </div>
            </div>
            <div class="sectionWrapper"> 
                <div v-if="((this.keywords?.length === 0 || this.keywords?.some(item => item.bid_price == 0)) && this.validationErrorMessage || this.errorMessage)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                    <div  class="errorHeading" ><img alt="img" src="../assets/errorIcon.svg" style="width: 20px; height: 20px; margin-right: 14px"/> {{ this.validationErrorMessage || this.errorMessage}}</div>
                </div>
                <ProductSelection 
                    v-bind:targeting="true" 
                    :clearForm="clearProductSelection" 
                    :clearTargeting="clearProductSelectionTargeting" 
                    :title="this.selectedTargetingType" 
                    @categoriesAdded="getCategoriesFromChild"
                    @CsvUploadLimitExceeded="CsvUploadLimitExceededFromChild"
                    @clearErrorMessage="onClearErrorMessage"
                    :campaignData="this.campaignData"
                    :keywords="this.keywordsArray"
                    :count="this.count"
                    :isdisabled="this.isDisabled"
                    :showViewSuggestionsBtn = this.showViewSuggestionsBtn
                    :selectionType="'keywords'"
                    :updatedSelectedProducts = this.products
                />
            </div>
        </div>
    </div>
</template>

<script>
import ProductSelection from './ProductSelection.vue';
import { toRaw } from 'vue';
import { mapState, mapActions } from 'vuex';
import { debounce, isEmpty } from 'lodash';
import { getCookie } from '@/services/campaignService';

export default {
    name: 'AdGroup',
    data() {
        return {
            // targetingType: "Keyword",
            adGroupName: this.name ? this.name : this.currentAdGroupName,
            clearProductSelection: false,
            clearProductSelectionTargeting: false,
            collapseClicked: false,
            products: this.productsArray ?? [],
            keywords: this.key ?? [],
            isDisabled: this.isdisabled,
            searchedProducts: this.searchedProductsArray,
            errorMessage: '',
            showViewSuggestionsBtn: false,
            role: getCookie('role')
        }
    },
    props: {
        adGroupTitle: String,
        targeting: Boolean,
        count: Number,
        clear: Boolean,
        campaignData: Object,
        isOpen: Boolean,
        selectedTargetingType: String,
        validationErrorMessage: String,
        validationErrorMessageForAdGroupName: String,
        productsArray: Array,
        keywordsArray: Array,
        sellerIdRole: String,
        prefilledData: Object,
        name: String,
        adGroup: Array,
        isdisabled: Boolean,
        adGroupState: Number,
        adGroupStateMessage: String,
        searchedProductsArray: Array
    },
    components: {
        ProductSelection,
    },   
    mounted(){
        const adGroup = toRaw(this.adGroup);
        const count = this.count;

        if (adGroup && count >= 0 && count < adGroup.length) {
            this.adGroupName = adGroup[count]?.adGroupName 
        }

        this.keywords = this.keywordsArray
        this.collapseClicked = false
        this.products = this.productsArray
        this.handleInputDebounced = debounce(this.checkInputChange, 500);
    },
    computed :{
        ...mapState(['currentAdGroupName','addGroupList','campaignClass']),
    },
    watch: {
        clear(newVal, OldVal){
            if(newVal){
                this.onFormClear();
            }
        }
    },

    methods: {
        ...mapActions(['setCurrentAdGroupName']),
        onInvalidCsvUpload(){
            this.errorMessage = 'Upload a valid CSV'
        },
        onClearErrorMessage(){
            this.errorMessage=''
        },
        checkInputChange(){
            this.$emit('adGroupData', {adGroupName: this.adGroupName, productIds: this.products, count : this.count, searchedProducts: this.searchedProducts,isOpen: true })
        },
        onFormClear() {
            this.adGroupName = null;
            this.clearProductSelection = true
        },
        getProductsFromChild(value, searchedProducts,isOpen){
            this.products = toRaw(value);
            if(this.products.length>0){
                this.showViewSuggestionsBtn = true;
            }else{
                this.showViewSuggestionsBtn = false;
            }
            this.searchedProducts = searchedProducts;
            let adGroupName = this.adGroupName
            this.$emit('adGroupData', {adGroupName: this.adGroupName, productIds: value,count : this.count, searchedProducts: searchedProducts, isOpen: isOpen})
            this.setCurrentAdGroupName(adGroupName);
        },
        getCategoriesFromChild(value, suggestions, keywordMatch){
            this.keywords = toRaw(value);
            this.$emit('adGroupTargetingData', {adGroupName: this.adGroupName,targetingValues: value,count : this.count, suggestions: suggestions, keywordMatch})
        },
        onDeleteAdGroupClick(){
            this.$emit('deleteAdgroupClicked',this.count);
            this.clearLocalStorage();
        },
        CsvUploadLimitExceededFromChild(value){
            console.log("inside ad exceeds",value)
            this.$emit('CsvUploadLimitExceeded',value);
        },
        isValidAdGroupName() {
            const pattern = /^[^%^₨`,.()]+$/;
            const isValidName = pattern.test(this.adGroupName);
            return isValidName
        }
    }
}
</script>


<style scoped>
    .heading{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
        margin-bottom: 12px;
    }

    .errorContainer{
        background: #FDEDED;
        border-radius: 8px;
        margin: 1%;
        padding: 18px 24px;
    }

    .collapseICon{
        width: 26px;
        height: 26px;
        position: absolute;
        top: -12px;
        right: 10px;
        cursor: pointer;
    }

    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E0E0E0;
        padding: 0 24px;
    }

    .deleteBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        color: #A80000;
        padding: 10px 36px;
        border: 1px solid #A80000;
        background: #FFFFFF;
        border-radius: 4px;
        cursor: pointer;
        margin-bottom: 10px;
    } 

    .errorHeading{
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
        color: #EB5757;
        /* margin-bottom: 12px; */
        display: flex;
    }
    
    .adGroup{
        position: relative;
        display: flex;
        flex-direction: column;
        margin: 0 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 0 0;
        /* border-radius: 12px; */
        border-bottom: 1px solid #E0E0E0;
    }

    .sectionWrapper{
        padding: 0 24px 36px;
        margin-top: 32px;

    }

    .none{
        display: none;
    }

    .block{
        display: block;
    }

    .section {
        margin-bottom: 14px;
    }

    .radioBtn{
        margin-right: 170px;
    }
     .title{
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        color: #666666;
        padding: 10px 0;
        padding-top: 0;
        /* border-bottom: 1px solid #E0E0E0;
        margin-bottom: 32px; */
    }

    .checkboxClass{
        display: flex;
    }

    .text{
        margin-left: 176px;
    }

    .content{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .textbox{
        width: 100%;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        /* color: #9B9B9B; */
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        max-width: 246px;
    }

    .warningContainer{
        background: #fff9f3;
        border-radius: 8px;
        margin: 1%;
        padding: 18px 24px;
    }
    .warningHeading{
        font-weight: 700;
        font-size: 14px;
        line-height: 140%;
        color: #EA7C0CC4;
        /* margin-bottom: 12px; */
        display: flex;
    }
    .disableCampaign {
        pointer-events: none;
    }
    .required::after {
        content: '*';
        color: #eb5757; 
        margin-left: 4px; 
        font-weight: bold;
    }
</style>